import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

export interface Title {
  title?: any;
  subtitle?: string;
  ngClass?: string[];
  divider?: boolean;
  show_info?: boolean;
  titleFontSize?: string;
}

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent implements OnInit {

  private _data: Title;
  get data() {
    return this._data;
  }
  @Input() set data(title: Title) {
    this._data = title;
  }

  @Output() onInfoClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  infoClick() {
    this.onInfoClick.emit();
  }
}
